var map = {
	"./Q10_Slide57.JPG": "857f",
	"./Q11_Slide58.JPG": "758b",
	"./Q12_Slide59.JPG": "ef88",
	"./Q13_Slide60.JPG": "ddb4",
	"./Q14_Slide61.JPG": "9227",
	"./Q15_Slide62.JPG": "6665",
	"./Q16_Slide63.JPG": "c9d7",
	"./Q1_1VDO_Slide5.JPG": "6c0b",
	"./Q1_2QA_Slide6.JPG": "8234",
	"./Q1_A1_Slide8.JPG": "3782",
	"./Q1_A2_Slide9.JPG": "b98c",
	"./Q1_A3_Slide10.JPG": "db9c",
	"./Q2_1Slide_Slide11.JPG": "a756",
	"./Q2_2VDO_Slide12.JPG": "4cc1",
	"./Q2_3QA1_Slide14.JPG": "a035",
	"./Q2_A1_Slide15.JPG": "db81",
	"./Q2_A2_Slide16.JPG": "f7d3",
	"./Q2_A3_Slide17.JPG": "4b70",
	"./Q3_1Slide_Slide18.JPG": "297f",
	"./Q3_2VDO_Slide19.JPG": "bb1b",
	"./Q3_3QA_Slide21.JPG": "136f",
	"./Q3_A1_Slide22.JPG": "5653",
	"./Q3_A2_Slide23.JPG": "9f1d",
	"./Q3_A3_Slide24.JPG": "3f6c",
	"./Q4_1VDO_Slide25.JPG": "97fe",
	"./Q4_2VDO_Slide26.JPG": "88f9",
	"./Q4_3QA_Slide28.JPG": "cec2",
	"./Q4_A1_Slide29.JPG": "3bd5",
	"./Q4_A2_Slide30.JPG": "a961",
	"./Q4_A3_Slide31.JPG": "9ceb",
	"./Q5_1VDO_Slide32.JPG": "4df6",
	"./Q5_2Slide1_Slide33.JPG": "ce08",
	"./Q5_2Slide2_Slide34.JPG": "18c6",
	"./Q5_2Slide3_Slide35.JPG": "8f3a",
	"./Q5_3VDO_Slide36.JPG": "7753",
	"./Q5_4QA_Slide38.JPG": "8e28",
	"./Q5_A1_Slide39.JPG": "5ae2",
	"./Q5_A2_Slide40.JPG": "1617",
	"./Q5_A3_Slide41.JPG": "c861",
	"./Q6_1VDO_Slide42.JPG": "6e24",
	"./Q6_2Slide_Slide43.JPG": "b7ce",
	"./Q6_3VDO_Slide44.JPG": "e68c",
	"./Q6_4QA_Slide46.JPG": "92cc",
	"./Q6_A1_Slide47.JPG": "67f6",
	"./Q6_A2_Slide48.JPG": "10f1",
	"./Q6_A3_Slide49.JPG": "ec4e",
	"./Q7_1VDO_Slide50.JPG": "c729",
	"./Q7_2VDO_Slide51.JPG": "3a9a",
	"./Q7_3Slide_Slide52.JPG": "9894",
	"./Q7_4Quiz_Slide53.JPG": "b0ff",
	"./Q7_Slide54.JPG": "cf0f",
	"./Q8_Slide55.JPG": "daad",
	"./Q9_Slide56.JPG": "5fe3",
	"./popup10.png": "7fb2",
	"./popup11.png": "aafb",
	"./popup12.png": "54b1",
	"./popup13.png": "08ad",
	"./popup14.png": "9f28",
	"./popup15.png": "4870",
	"./popup16.png": "39bf",
	"./popup7.png": "0a30",
	"./popup8.png": "f4a7",
	"./popup9.png": "a6d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bd96";